export class EmployeeDesignationDTO {
  public employeeDesignationCode: string;
  public description: string;
  public status: string;
  public user: string;
  public url: string;


  constructor(employeeDesignationCode: string, description: string, status: string, user: string ,url: string) {
    this.employeeDesignationCode = employeeDesignationCode;
    this.description = description;
    this.status = status;
    this.user = user;
    this.url = url;
  }
}
